import { isValid, parse } from "date-fns";

export const getTimeFromTimeString = (timeValue?: string): Date | null => {
	if (!timeValue) return null;
	const ref = new Date(2000, 0, 1);
	for (const fmt of ["HH:mm:ss", "HH:mm", "h:mm aa", "h:mm a"]) {
		const result = parse(timeValue, fmt, ref);
		if (isValid(result)) return result;
	}
	return null;
};
